window._regenerateInProgress = false;
window.regenerateResponse = function(threadId) {
  if (window._regenerateInProgress) return;
  window._regenerateInProgress = true;

  var csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  var url = '/chats/threads/' + threadId + '/regenerate';

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    }
  })
  .then(function(response) {
    if (!response.ok) {
      console.error('Regenerate failed with status: ' + response.status);
    }
  })
  .catch(function() {
    console.error('Failed to regenerate response');
  })
  .finally(function() {
    // Allow regenerate again after a short delay to prevent accidental double-clicks
    // but still permit intentional retries
    setTimeout(function() { window._regenerateInProgress = false; }, 3000);
  });
}

window.toggleReviewPanel = function(panelId) {
  // Close any open download panels
  document.querySelectorAll('.download-options').forEach(function(el) {
    el.classList.add('d-none');
  });
  // Close any other open review panels
  document.querySelectorAll('.review-model-options').forEach(function(el) {
    if (el.id !== panelId) el.classList.add('d-none');
  });

  var panel = document.getElementById(panelId);
  if (!panel) return;

  panel.classList.toggle('d-none');

  if (!panel.classList.contains('d-none')) {
    setTimeout(function() {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }
}

window.toggleDownloadPanel = function(panelId) {
  // Close any open review panels
  document.querySelectorAll('.review-model-options').forEach(function(el) {
    el.classList.add('d-none');
  });
  // Close any other open download panels
  document.querySelectorAll('.download-options').forEach(function(el) {
    if (el.id !== panelId) el.classList.add('d-none');
  });

  var panel = document.getElementById(panelId);
  if (!panel) return;

  panel.classList.toggle('d-none');

  if (!panel.classList.contains('d-none')) {
    setTimeout(function() {
      panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }
}

window.submitReview = function(threadId, reviewModelId) {
  var csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  var url = '/chats/threads/' + threadId + '/review';

  // Get the model name from the clicked button
  var btn = event.currentTarget;
  var modelName = btn.textContent.trim();

  // Close all review dropdowns
  document.querySelectorAll('.review-model-options').forEach(function(el) {
    el.classList.add('d-none');
  });

  var listMessages = document.getElementById('list-messages');
  if (!listMessages) return;

  // Add breathing room spacer so the review doesn't sit at the very bottom
  var spacer = document.createElement('div');
  spacer.id = 'review-spacer';
  spacer.style.height = '120px';
  spacer.style.flexShrink = '0';
  listMessages.appendChild(spacer);

  // Append a loading placeholder
  var placeholder = document.createElement('div');
  placeholder.id = 'review-loading-placeholder';
  placeholder.className = 'message msg msg-assistant fade-in';
  placeholder.innerHTML = '<div class="msg-sender">' +
    '<div class="sender-name sender-assistant">' + modelName +
    ' <span class="review-badge ml-2"><span class="far fa-check-circle mr-1"></span>Review</span></div></div>' +
    '<div class="msg-body p-3"><div class="d-flex align-items-center review-loading-text">' +
    '<div class="inline-block float-left chat-loader mr-2"></div>' +
    '<span class="font-size-14">Reviewing response...</span></div></div>';
  listMessages.insertBefore(placeholder, spacer);

  // Scroll to show the placeholder with breathing room
  var scrollContainer = listMessages.closest('.card-body') || listMessages.parentElement;
  if (scrollContainer) {
    scrollContainer.scrollTo({
      top: scrollContainer.scrollHeight,
      behavior: 'smooth'
    });
  }

  // Set up auto-scroll observer for streaming content
  var reviewScrollObserver = new MutationObserver(function() {
    if (!scrollContainer) return;

    // Only auto-scroll if user is near the bottom (within 200px)
    var distanceFromBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight;
    if (distanceFromBottom < 200) {
      scrollContainer.scrollTo({
        top: scrollContainer.scrollHeight,
        behavior: 'smooth'
      });
    }
  });

  reviewScrollObserver.observe(listMessages, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Remove placeholder once real message arrives via Turbo, clean up when done
  var placeholderRemoved = false;
  var cleanupObserver = new MutationObserver(function(mutations) {
    // Remove placeholder as soon as any new message is appended by Turbo
    if (!placeholderRemoved) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && mutations[i].addedNodes.length > 0) {
          for (var j = 0; j < mutations[i].addedNodes.length; j++) {
            var node = mutations[i].addedNodes[j];
            if (node.nodeType === 1 && node.id !== 'review-loading-placeholder' && node.id !== 'review-spacer' && node.classList && node.classList.contains('message')) {
              var el = document.getElementById('review-loading-placeholder');
              if (el) el.remove();
              placeholderRemoved = true;
              break;
            }
          }
        }
        if (placeholderRemoved) break;
      }
    }

    // Check if streaming is done (no more inline-cursor visible)
    var inlineCursor = listMessages.querySelector('.inline-cursor');
    var chatLoader = listMessages.querySelector('.chat-loader');
    if (!inlineCursor && !chatLoader && !document.getElementById('review-loading-placeholder')) {
      // Review is complete, remove spacer and disconnect observers
      var spacerEl = document.getElementById('review-spacer');
      if (spacerEl) spacerEl.remove();
      reviewScrollObserver.disconnect();
      cleanupObserver.disconnect();
    }
  });

  cleanupObserver.observe(listMessages, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // Safety timeout: clean up everything after 120s regardless
  setTimeout(function() {
    var el = document.getElementById('review-loading-placeholder');
    if (el) el.remove();
    var spacerEl = document.getElementById('review-spacer');
    if (spacerEl) spacerEl.remove();
    reviewScrollObserver.disconnect();
    cleanupObserver.disconnect();
  }, 120000);

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken
    },
    body: JSON.stringify({ review_model_id: reviewModelId })
  })
  .catch(function() {
    var el = document.getElementById('review-loading-placeholder');
    if (el) {
      el.querySelector('.msg-body').innerHTML = '<p class="opacity-5 p-3">Unable to start review. Please try again.</p>';
    }
    // Clean up spacer on error
    var spacerEl = document.getElementById('review-spacer');
    if (spacerEl) spacerEl.remove();
    reviewScrollObserver.disconnect();
    cleanupObserver.disconnect();
  });
}
